import Layout from "@/components/Layout";
import PageHero from "@/components/PageHero";
import { motion } from "framer-motion";
import { Calendar, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";

const blogPosts = [
  {
    id: 1,
    title: "How to Choose the Right Flooring for Your Home",
    excerpt: "A comprehensive guide to selecting the perfect flooring material based on your lifestyle, budget, and design preferences.",
    date: "Coming Soon",
    category: "Guides",
    image: "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=800&auto=format&fit=crop",
  },
  {
    id: 2,
    title: "Hardwood vs. Luxury Vinyl: Which is Right for You?",
    excerpt: "Compare the pros and cons of hardwood and luxury vinyl plank flooring to make an informed decision.",
    date: "Coming Soon",
    category: "Comparisons",
    image: "https://images.unsplash.com/photo-1581858726788-75bc0f6a952d?w=800&auto=format&fit=crop",
  },
  {
    id: 3,
    title: "Top Flooring Trends for 2024",
    excerpt: "Discover the latest flooring trends that are transforming homes across Charlotte and beyond.",
    date: "Coming Soon",
    category: "Trends",
    image: "https://images.unsplash.com/photo-1595428774223-ef52624120d2?w=800&auto=format&fit=crop",
  },
];

const Blog = () => {
  return (
    <Layout>
      <PageHero
        title="Flooring Blog"
        subtitle="Tips, trends, and expert advice for your flooring projects."
        breadcrumbs={[
          { label: "Home", href: "/" },
          { label: "Blog" },
        ]}
      />

      <section className="section-padding bg-background">
        <div className="container-wide">
          {/* Coming Soon Banner */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="bg-primary/5 border border-primary/20 rounded-2xl p-8 md:p-12 text-center mb-16"
          >
            <h2 className="heading-md text-foreground mb-4">Blog Coming Soon!</h2>
            <p className="body-md text-muted-foreground max-w-2xl mx-auto mb-6">
              We're working on bringing you helpful content about flooring, home improvement, and design inspiration. 
              Check back soon for articles from our experts!
            </p>
            <Button asChild>
              <Link to="/free-estimate">
                Get a Free Estimate Instead
                <ArrowRight className="ml-2 h-4 w-4" />
              </Link>
            </Button>
          </motion.div>

          {/* Preview Posts */}
          <div className="mb-8">
            <h3 className="heading-sm text-foreground mb-2">Coming Up</h3>
            <p className="text-muted-foreground">Here's a preview of what we're working on:</p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {blogPosts.map((post, index) => (
              <motion.article
                key={post.id}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.1 }}
                className="group bg-card rounded-xl overflow-hidden shadow-sm hover:shadow-lg transition-all duration-300 border border-border"
              >
                <div className="aspect-[16/10] overflow-hidden">
                  <img
                    src={post.image}
                    alt={post.title}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105 opacity-70"
                    loading="lazy"
                  />
                </div>
                <div className="p-6">
                  <div className="flex items-center gap-3 mb-3">
                    <span className="text-xs font-medium px-2.5 py-1 bg-primary/10 text-primary rounded-full">
                      {post.category}
                    </span>
                    <span className="flex items-center gap-1 text-xs text-muted-foreground">
                      <Calendar className="h-3 w-3" />
                      {post.date}
                    </span>
                  </div>
                  <h3 className="font-semibold text-foreground text-lg mb-2 group-hover:text-primary transition-colors">
                    {post.title}
                  </h3>
                  <p className="text-sm text-muted-foreground line-clamp-2">{post.excerpt}</p>
                </div>
              </motion.article>
            ))}
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default Blog;
